<template>
<div>
  <nav class="navbar navbar-expand-lg">
    <div class="container" style="margin-top: 0px;">
      <a class="navbar-brand" @click="jump('/')" style="cursor: pointer;">
        <span class="brand-icon">&#128218;</span>
        <span class="brand-text">AP 编程课堂</span>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav" style="justify-content: end;">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" @click="jump('/')">
              <i class="fas fa-home"></i> 首页
            </a>
          </li>

            <li class="nav-item" v-if="$store.state.user != null">
              <a class="nav-link" href="/center">
                <i class="fas fa-user-circle"></i> 个人中心
              </a>
            </li>
            <li class="nav-item" v-if="$store.state.user == null">
              <a class="nav-link nav-link-login" @click="login" id="login-a">
                <i class="fas fa-sign-in-alt"></i> 登录
              </a>
            </li>
            <li class="nav-item" v-else>
              <a class="nav-link nav-link-logout"  @click="loginout">
                <i class="fas fa-sign-out-alt"></i> 退出
              </a>
            </li>

        </ul>
      </div>
    </div>
  </nav>

  <!-- Login Dialog Modal -->
  <div v-if="showLoginDialog" class="login-modal-overlay" @click.self="showLoginDialog = false">
    <div class="login-modal-dialog">
      <div class="login-modal-content">
        <div class="login-modal-header">
          <h5 class="login-modal-title">
            <i class="fas fa-lock"></i> 登录系统
          </h5>
          <button type="button" class="login-modal-close" @click="showLoginDialog = false">&times;</button>
        </div>
        <div class="login-modal-body">
          <div style="padding:20px 15px;position: relative;" >
            <div style="margin-bottom: 15px;">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                </div>
                <input class="form-control" placeholder="请输入帐号" v-model="mobile"/>
              </div>
            </div>
            <div style="margin-bottom: 10px;">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input class="form-control" placeholder="请输入密码" v-model="code" type="password"/>
              </div>
            </div>
          </div>
        </div>
        <div class="login-modal-footer">
          <button type="button" class="btn btn-secondary" @click="showLoginDialog = false">取消</button>
          <button type="button" class="btn btn-primary" @click="onLogin()">
            <i class="fas fa-sign-in-alt"></i> 登录
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import bus from '../utils/bus';

export default{
  data(){
    return{
      mobile:"",
      code:"",
      loadingText:"发送验证码",
      showLoginDialog: false
    }
  },
  mounted(){
    let userStorage = window.localStorage.getItem("user");
    if(userStorage != null && userStorage != ""){
      let userObj = JSON.parse(userStorage);
      this.$store.commit('updateUser',userObj);
    }
  },
    methods:{
        jump(url){
            location.href=url;
        },
        startClass(){
            location.href="/class?target=17391200805&mobile="+this.$store.state.user.mobile;
        },
        login(){
          this.mobile = "";
          this.code = "";
          this.showLoginDialog = true;
        },
        onLogin(){
          let postInfo = {};
          postInfo.mobile = this.mobile;
          postInfo.captcha = this.code;

          this.$http.post('https://programapi.dctechonline.cn/api/ap/login',postInfo).then(res=>{
              var result = res.data;
              if(result!=null){
                this.$store.commit('updateUser',result);
                window.localStorage.setItem("user",JSON.stringify(result));
                this.showLoginDialog = false;
                location.href='/center';
              }
              else{
                alert(result.message);
              }
            })
        },
        loginout(){
          this.$store.commit('updateUser',null);
          window.localStorage.setItem("user","");
          bus.$emit('logout');
          location.href = '/';
        },
        sendCode(){
          if(this.mobile == ""){
            alert('请先输入手机号码');
          }
          else{
            const phoneRegex = /^1[3-9]\d{9}$/;
            const phoneNumber = this.mobile;
            if (!phoneRegex.test(phoneNumber)) {
              alert('手机号码格式错误');
              return;
            }

            if(this.loadingText != "发送验证码"){
              return;
            }

            var timer = 90;
            this.loadingText = timer +"秒后重发";
            var inter = setInterval(()=>{
              timer --;
              this.loadingText = timer +"秒后重发";
              

              if(timer == 0){
                this.loadingText = "发送验证码";
                clearInterval(inter);
              }
            },1000);
            
            this.$http.post('https://programapi.dctechonline.cn/api/ap/code',{
              mobile:this.mobile
            }).then(res=>{
              
              
            })
          }
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.navbar{
    position: fixed;
    top:0px;
    left:0px;
    width:100%;
    z-index:100;
    background: linear-gradient(135deg, rgba(13, 148, 136, 0.95) 0%, rgba(20, 184, 166, 0.95) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 12px 0;

    .navbar-brand {
      display: flex;
      align-items: center;
      gap: 10px;
      color: white !important;
      font-weight: 700;
      font-size: 20px;
      transition: all 0.3s ease;
      
      .brand-icon {
        font-size: 24px;
        filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
      }
      
      .brand-text {
        background: linear-gradient(90deg, #fff, #e0f2f1);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      &:hover {
        transform: scale(1.02);
      }
    }

    a.nav-link{
      cursor: pointer;
      color: rgba(255, 255, 255, 0.9) !important;
      font-weight: 500;
      font-size: 14px;
      padding: 8px 16px !important;
      border-radius: 8px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 6px;

      i {
        font-size: 13px;
      }

      &:hover{
        background: rgba(255, 255, 255, 0.15);
        color: white !important;
        transform: translateY(-1px);
      }
      
      &.nav-link-login {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        
        &:hover {
          background: white;
          color: $primary-color !important;
        }
      }
      
      &.nav-link-logout {
        background: rgba(239, 68, 68, 0.2);
        border: 1px solid rgba(239, 68, 68, 0.3);
        
        &:hover {
          background: #ef4444;
          color: white !important;
        }
      }
    }
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.9);
}

.nav-item{
  margin:0px 4px;
  font-size:15px;
}

.modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
  color: white;
  border: none;
  padding: 20px 24px;
  
  .modal-title {
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .close {
    color: white;
    opacity: 0.8;
    text-shadow: none;
    
    &:hover {
      opacity: 1;
    }
  }
}

.modal-body {
  padding: 24px;
  
  .input-group-text {
    background: $bg-secondary;
    border: 1px solid $border-color;
    color: $primary-color;
  }
  
  .form-control {
    border: 1px solid $border-color;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.3s ease;
    
    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
    }
  }
}

.modal-footer {
  border-top: 1px solid $border-light;
  padding: 16px 24px;
  
  .btn-secondary {
    background: $bg-secondary;
    border: none;
    color: $text-secondary;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 500;
    
    &:hover {
      background: darken($bg-secondary, 5%);
    }
  }
  
  .btn-primary {
    background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba($primary-color, 0.4);
    }
  }
}

.navbar-toggler {
  border: none;
  padding: 8px 12px;
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

// Login Modal Styles
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.login-modal-dialog {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: loginModalSlideIn 0.3s ease;
}

@keyframes loginModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-modal-content {
  width: 100%;
}

.login-modal-header {
  background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .login-modal-title {
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    margin: 0;
  }

  .login-modal-close {
    background: none;
    border: none;
    color: white;
    font-size: 28px;
    cursor: pointer;
    opacity: 0.8;
    padding: 0;
    line-height: 1;

    &:hover {
      opacity: 1;
    }
  }
}

.login-modal-body {
  padding: 24px;

  .input-group-text {
    background: $bg-secondary;
    border: 1px solid $border-color;
    color: $primary-color;
  }

  .form-control {
    border: 1px solid $border-color;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.3s ease;

    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
    }
  }
}

.login-modal-footer {
  border-top: 1px solid $border-light;
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .btn-secondary {
    background: $bg-secondary;
    border: none;
    color: $text-secondary;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background: darken($bg-secondary, 5%);
    }
  }

  .btn-primary {
    background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 500;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba($primary-color, 0.4);
    }
  }
}
</style>
